import { Component, ViewEncapsulation, OnInit, ViewContainerRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastUtilsService } from '../shared/services/api/toast-utils.service';

@Component({
    selector: 'app-style-guide',
    templateUrl: './style-guide.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class StyleGuideComponent implements OnInit {
    cats = [
        {
            count: 1,
            category: 'Aegean',
        },
        {
            count: 0,
            category: 'American',
        },
        {
            count: 4,
            category: 'Lykoi',
        },
    ];

    email;
    radioModel;
    onEnterForm;
    checkboxModel;
    toggleModel;
    action;
    detail;
    checked;
    selectModel;
    showDetail;
    myUser;
    searchText;
    search;
    pdfSrc = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';

    itemProduct = { id: '33', title: 'mi producto', price: 6 };

    dropdownList = [];
    selectedItems = [];
    dropdownSettings = {};

    constructor(public router: Router) {}

    ngOnInit() {
        this.initSelectMultiple();
    }

    initSelectMultiple() {
        this.dropdownList = [
            { item_id: 1, item_text: 'Mumbai' },
            { item_id: 2, item_text: 'Bangaluru' },
            { item_id: 3, item_text: 'Pune' },
            { item_id: 4, item_text: 'Navsari' },
            { item_id: 5, item_text: 'New Delhi' },
        ];
        this.selectedItems = [
            { item_id: 3, item_text: 'Pune' },
            { item_id: 4, item_text: 'Navsari' },
        ];
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'item_id',
            textField: 'item_text',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 3,
            allowSearchFilter: true,
        };
    }

    onItemSelect(item: any) {
        console.log(item);
    }
    onSelectAll(items: any) {
        console.log(items);
    }

    showToast(event) {
        event.preventDefault();

        const options = { duration: 30000 };
        // this.toastUtilsService.setToastMode(success, this.renderer);
    }
}
